export default __webpack_public_path__ + "static/media/icon-kenh-14.9cdec051.png";